(function () {
  const revealSelector = '.y486-reveal, .y486-hero-text-reveal';

  function revealElement(element) {
    element.classList.add('y486-is-visible');
  }

  function replayPanel(panel) {
    if (!panel) return;

    const items = Array.from(panel.querySelectorAll(revealSelector));
    items.forEach((item) => {
      item.classList.remove('y486-is-visible');
      void item.offsetWidth;
      revealElement(item);
    });
  }

  function initY486Animations(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll(revealSelector).forEach(revealElement);
      return;
    }

    const items = Array.from((root || document).querySelectorAll(revealSelector));
    if (!items.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealElement(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.08,
      }
    );

    items.forEach((item) => observer.observe(item));
  }

  document.addEventListener('DOMContentLoaded', () => {
    initY486Animations(document);

    document.addEventListener('click', (event) => {
      const tabButton = event.target.closest('.y486-product-tabs .tab-button');
      if (!tabButton) return;

      setTimeout(() => {
        replayPanel(document.getElementById(tabButton.dataset.tab));
      }, 80);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initY486Animations(event.target);
  });
})();
